export default "__VITE_ASSET__e18d54a0__"